{
  "level": "mt05mov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt05mov",
    "objects": "AREAS.E3:mt05mov.e3",
    "mesh": "TREES.E3:mt05mov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -0.0,
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        0.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: fdrt",
      "entity_class": "CSlidingDoor",
      "piece_name": "fdrt",
      "offset": 552,
      "centroid": [
        -383.8232421875,
        -2114.438232421875,
        652.0499877929688
      ],
      "bbox_min": [
        -392.425537109375,
        -2119.837646484375,
        648.0
      ],
      "bbox_max": [
        -375.220947265625,
        -2109.038818359375,
        656.0999755859375
      ],
      "dimensions_source": {
        "span_x": 17.20458984375,
        "span_y": 10.798828125,
        "height_z": 8.0999755859375,
        "door_width": 17.20458984375,
        "door_depth": 10.798828125,
        "leaf_depth": 10.758828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -375.970947265625,
          -2109.038818359375,
          648.0
        ],
        [
          -392.425537109375,
          -2118.538818359375,
          648.0
        ],
        [
          -375.970947265625,
          -2109.038818359375,
          656.0999755859375
        ],
        [
          -392.425537109375,
          -2118.538818359375,
          656.0999755859375
        ],
        [
          -391.675537109375,
          -2119.837646484375,
          648.0
        ],
        [
          -375.220947265625,
          -2110.337646484375,
          648.0
        ],
        [
          -391.675537109375,
          -2119.837646484375,
          656.0999755859375
        ],
        [
          -375.220947265625,
          -2110.337646484375,
          656.0999755859375
        ]
      ],
      "plane_distance": 648.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: fdrb",
      "entity_class": "CSlidingDoor",
      "piece_name": "fdrb",
      "offset": 1661,
      "centroid": [
        -383.8232421875,
        -2114.438232421875,
        644.0
      ],
      "bbox_min": [
        -392.425537109375,
        -2119.837646484375,
        640.0
      ],
      "bbox_max": [
        -375.220947265625,
        -2109.038818359375,
        648.0
      ],
      "dimensions_source": {
        "span_x": 17.20458984375,
        "span_y": 10.798828125,
        "height_z": 8.0,
        "door_width": 17.20458984375,
        "door_depth": 10.798828125,
        "leaf_depth": 10.758828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -375.970947265625,
          -2109.038818359375,
          648.0
        ],
        [
          -392.425537109375,
          -2118.538818359375,
          648.0
        ],
        [
          -392.425537109375,
          -2118.538818359375,
          640.0
        ],
        [
          -375.970947265625,
          -2109.038818359375,
          640.0
        ],
        [
          -391.675537109375,
          -2119.837646484375,
          648.0
        ],
        [
          -375.220947265625,
          -2110.337646484375,
          648.0
        ],
        [
          -375.220947265625,
          -2110.337646484375,
          640.0
        ],
        [
          -391.675537109375,
          -2119.837646484375,
          640.0
        ]
      ],
      "plane_distance": -648.0,
      "authentic_texture": "doorjam"
    }
  ],
  "tutorial_messages": []
}